import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

type Props = {
  open: boolean;
  title?: string;
  errors: string[];
  onClose: () => void;
};

export function ValidationErrorsDialog({
  open,
  title = "Please fix the following",
  errors,
  onClose,
}: Readonly<Props>) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#111",
          color: "#fff",
          border: "1px solid #333",
        },
      }}
    >
      <DialogTitle sx={{ color: "hsl(19 101% 51% / 1)" }}>{title}</DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "#ccc", mb: 1, fontSize: "0.9rem" }}>
          The form could not be saved because of the issues below:
        </Typography>
        <List dense disablePadding>
          {errors.map((error) => (
            <ListItem key={error} disableGutters sx={{ py: 0.25 }}>
              <ListItemText
                primary={`• ${error}`}
                primaryTypographyProps={{ sx: { color: "#fff", fontSize: "0.9rem" } }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "hsl(19 101% 51% / 1)",
            "&:hover": { backgroundColor: "hsl(19 101% 41% / 1)" },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
